<template>
  <div v-if="item">
    <fields-list :item="item" :fields="fields" />
    <button class="btn btn-warning btn-icon" @click="updateItem">
      <span class="ti-save"></span>{{ "save" | setText("Сохранить") }}
    </button>
    <hr />
    <videoChat :item="item" :close="close" />
  </div>
</template>
<script>
import { cardUpdate, cardContent, pushLang } from "@/plugins/functions";

export default {
  data: () => ({
    cardLink: "business/conferences",
    cardSetLink: "business/conferences",
    item: null,
    fields: [
      {
        col: "col-12 col-md-4 col-lg-3",
        label: "Время начало",
        key: "start_at",
        type: "datetime",
      },
      {
        label: "Активность",
        key: "is_active",
        type: "hidden",
      },
      {
        col: "col-12 col-md-4 col-lg-3",
        key: "title",
        label: "Название",
        type: "field",
        textType: "text",
      },
    ],
  }),
  props: ["id"],
  async created() {
    this.item = await this.cardContent(this.cardLink, this.id);
  },
  destroyed() {
    this.close();
  },
  methods: {
    cardUpdate: cardUpdate,
    cardContent: cardContent,
    pushLang: pushLang,
    async updateItem() {
      let item = await this.cardUpdate(
        this.cardSetLink,
        this.item,
        this.fields
      );
    },
    close() {
      this.item["is_active"] = false;
      setTimeout(this.updateItem, 10);
    },
  },
};
</script>
<style>
</style>
